import { useTranslation } from 'react-i18next'
import { Wand2 } from 'lucide-react'
import { Button } from '@/components/v2/ui'
import { EID } from '@/lib/element-ids.registry'

interface PotentialRemakeCtaProps {
  onStartRemake: () => void
}

export function PotentialRemakeCta({ onStartRemake }: PotentialRemakeCtaProps) {
  const { t } = useTranslation()
  const r = (key: string) => t(`amazonListing.potentialCheck.${key}`)

  return (
    <div className="potential-check-remake-cta rounded-xl border border-neutral-200 dark:border-neutral-700 bg-gradient-to-br from-orange-50 to-amber-50 dark:from-orange-950/20 dark:to-amber-950/20 p-6 text-center">
      <div className="mx-auto mb-3 w-12 h-12 rounded-full bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
        <Wand2 className="w-6 h-6 text-orange-500" aria-hidden="true" />
      </div>
      <h3 className="text-base font-semibold text-neutral-900 dark:text-white mb-1">
        {r('remakeTitle')}
      </h3>
      <p className="text-sm text-neutral-500 dark:text-neutral-400 mb-4 max-w-md mx-auto">
        {r('remakeDescription')}
      </p>
      <Button
        id={EID['audit-potential-remake-btn']}
        variant="warning"
        className="potential-check-remake-btn"
        onClick={onStartRemake}
        iconLeft={<Wand2 className="w-4 h-4" />}
      >
        {r('remakeButton')}
      </Button>
    </div>
  )
}
